import { render } from "./BaseOverlay.vue?vue&type=template&id=11139740&scoped=true"
import script from "./BaseOverlay.vue?vue&type=script&lang=js"
export * from "./BaseOverlay.vue?vue&type=script&lang=js"

import "./BaseOverlay.vue?vue&type=style&index=0&id=11139740&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11139740"]])

export default __exports__